<template>
    <div>
        <i-table class="iview_table" :loading="isLoading" border :columns="columns" :data="datas">
<!--            <div slot="header">-->

<!--            </div>-->
        </i-table>
    </div>
</template>

<script>
    export default {
        name: "Wp_everyday_income_table",

        props: {
            pid: {type: String, default: null},
            start_time: {type: String, default: ''},
            end_time: {type: String, default: ''},
            tableData:{type: Array},
            // isLoading:{type: Boolean, default: true}
            column_num: {type: Number, default: 2}
        },

        data(){
            return{
                isLoading: true,

                columns: [
                    {
                        title: '日期',
                        key: 'date',
                    },
                    {
                        title: '预估收入',
                        key: 'date_income',

                    }
                ],

                columns_3: [
                    {
                        title: '日期',
                        key: 'date',
                    },
                    {
                        title: '订单量',
                        key: 'date_order_num',
                    },
                    {
                        title: '预估收入',
                        key: 'date_income',
                    }
                ],
                datas: [],
            }
        },

        created(){
            // this.getEverydayCountList();
            // this.datas = this.tableData;
            this.initTableData(this.tableData);
            // this.is_loading = this.isLoading;
        },

        watch:{
            start_time(){
                this.isLoading = true;
            },
            tableData(newData){
                if(newData && newData.length > 0){
                    this.initTableData(newData);
                    this.isLoading = false;
                    // this.getEverydayCountList();
                }

            },
        },

        methods:{

            initTableData(_data){
                this.datas = _data;
                if(this.column_num === 3){
                    this.columns = this.columns_3;
                }
            },

            // getEverydayCountList(){
            //     let params = {
            //         uid: this.$store.state.username,
            //         stime: this.start_time,
            //         etime: this.end_time
            //     }
            //
            //     this.$getEverydayCountList(params, response=>{
            //         this.$log(response)
            //         if(response && response.code === 200){
            //             this.isLoading = false;
            //             let datas = response.data;
            //             for(let i = 0; i < datas.length; i++){
            //                 this.datas.push({
            //                     date: datas[i].day,
            //                     date_income: Number(datas[i].efeetodayall).toFixed(2) + " 元"
            //                 })
            //                 this.income_data.push({
            //                     date: datas[i].day,
            //                     date_income: Number(datas[i].efeetodayall).toFixed(2)
            //                 })
            //             }
            //
            //             this.$emit("setIncomeDatas", this.income_data);
            //         }else if(response.toString().indexOf("Error: timeout") != -1){
            //             this.$dialog.confirm({
            //                 message: "数据加载超时，请重试"
            //             }).then(()=>{
            //                 this.getPidLevelCountList();
            //             }).catch(()=>{
            //                 this.isLoading = false;
            //             });
            //         }
            //
            //     })
            // }
        }
    }
</script>

<style >
    /*.ivu-table-wrapper.iview_table {*/
    /*    border: 1px solid #1989fa;*/
    /*    border-bottom: 0;*/
    /*    border-right: 0;*/

    /*    !*background: none!important;*!*/
    /*}*/

    /*.iview_table .ivu-table-border {*/
    /*    background: none;*/
    /*    color: inherit;*/
    /*}*/
    .iview_table .ivu-table-header tr {
        /*box-shadow: inset 0px 0px 12px 1px #232e3c;*/
        background-color: #219EFF;
        color: white;
    }
    .iview_table .ivu-table-border td, .iview_table .ivu-table-border th {
        /*border-color: #1978e2;*/
        background: none;
        /*color: inherit;*/
        font-size: 14px;
    }

    /*.iview_table .ivu-table-row-hover {*/
    /*    background: #191f27;*/
    /*}*/
    /*.iview_table .ivu-table:before, .iview_table .ivu-table:after {*/
    /*    background-color: #1989fa;*/
    /*}*/
    /*.iview_table .ivu-form-item:not(.ivu-form-item-error) {*/
    /*    margin-bottom: 7px;*/
    /*}*/

</style>